import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetLinksMutation } from '../../redux/apis/linkManagement/changeGetLink/lMChangeGetLinkApiSlice'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import TextArea from 'antd/es/input/TextArea'
import { Modal } from 'antd'
import { useLazyGetUgcEpisodeLinkQuery } from '../../redux/apis/linkManagement/ugc/lMUgcEpisodeApiSlice'
import ReusableTable from '../../components/other/ReuseableTable'
import generateExcel from '../../helpers/generateExcel'
const GetLinksDetails = React.memo(() => {
  const context = useContext(AppSettings)
  const [query, setQuery] = useState([])
  const [get, { isLoading, error }] = useGetLinksMutation()
  const [episodeId, setEpisodeId] = useState(null)
  const [fetchEpisode, { data: episode, isFetching: episodeLoading, error: episodeError }] =
    useLazyGetUgcEpisodeLinkQuery()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      urls: ''
    },
    validationSchema: Yup.object({
      urls: Yup.string().required('Please Enter Urls')
    }),

    onSubmit: async values => {
      const urls = values.urls
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)

      try {
        let data = {
          urls: urls
        }
        const res = await get(data)
        setQuery(res?.data?.data)
      } catch (error) {
        console.error(error)
      }
    }
  })

  let columns = [
    {
      title: 'CAMPAIGN NAME',
      dataIndex: 'campaign_name',
      key: 'campaign_name',
      search: true
    },

    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      search: true,
      render:(text,record)=>(
        <p>{decodeURIComponent(text)}</p>
      )
    },
    {
      title: 'CRAWL DATE',
      dataIndex: 'crawl_date',
      key: 'crawl_date',
      search: true
    },
    {
      title: 'LINK TYPE',
      dataIndex: 'link_type',
      key: 'link_type',
      search: true
    },
    {
      // ponytail: same shape for Source and TubeURL (ok.ru) rows, so no model_name branch
      title: 'PARENT URL',
      dataIndex: 'parent',
      key: 'parent_url',
      render: parent => {
        if (!parent?.data?.url) return null
        const url = decodeURIComponent(parent.data.url)
        if (!parent.data.id) return <p>{url}</p>
        return (
          <button
            className='btn btn-link p-0 text-start text-break'
            onClick={() => {
              setEpisodeId(parent.data.id)
              fetchEpisode(parent.data.id)
            }}
          >
            {url}
          </button>
        )
      }
    },
    {
      title: 'REMOVE DATE',
      dataIndex: 'remove_date',
      key: 'remove_date',
      search: true
    },
    {
      title: 'REPORT DATE',
      dataIndex: 'report_date',
      key: 'report_date',
      search: true
    },
    {
      title: 'REVIEW DATE',
      dataIndex: 'review_date',
      key: 'review_date',
      search: true
    },
    {
      title: 'INSERTED BY',
      dataIndex: 'inserted_by',
      key: 'inserted_by',
      
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      
    }
  ]

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div className='flex flex-col gap-8'>
      <Loader isLoading={isLoading} />
      <Card>
        <CardHeader>Inquire Links</CardHeader>
        <CardBody>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">URLs (separated by new lines)</label>
            <TextArea
              type='text'
              name='urls'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.urls}
              placeholder='Enter urls separated by new lines
              example:
              test.com
              test2.com
              test3.com
              '
              rows={15}
            />
            {validation.touched.urls && validation.errors.urls ? (
              <p className='text-danger'>{validation.errors.urls}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => {
                validation.handleSubmit()
              }}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>

      {query?.length > 0 ? (
        <Card>
          <CardHeader className='d-flex justify-content-between align-items-center'>
            <span>Inquire Results</span>
            <button
              onClick={() =>
                generateExcel(
                  query.map(({ parent, ...item }) => ({
                    ...item,
                    parent_url: parent?.data?.url || ''
                  })),
                  'inquire_results'
                )
              }
              className='btn btn-theme'
            >
              Download
            </button>
          </CardHeader>
          <CardBody>
            <div className='row'>
              <ReusableTable columns={columns} data={query} />
            </div>
          </CardBody>
        </Card>
      ) : null}

      <Modal
        title='Episode Details'
        open={!!episodeId}
        onCancel={() => setEpisodeId(null)}
        footer={null}
        width={720}
      >
        {episodeLoading ? (
          <p>Loading...</p>
        ) : episodeError ? (
          <p className='text-danger'>Failed to load episode details</p>
        ) : (
          <table className='table table-sm mb-0'>
            <tbody>
              {Object.entries(episode?.data || {}).map(([key, value]) => (
                <tr key={key}>
                  <th className='text-capitalize'>{key.replace(/_/g, ' ')}</th>
                  <td className='text-break'>
                    {value === null || value === ''
                      ? '-'
                      : typeof value === 'object'
                      ? JSON.stringify(value)
                      : String(value)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal>
    </div>
  )
})

export default GetLinksDetails
